import { ApplicationExplorerMenuItem } from './ApplicationExplorerMenuItem';
import { DashboardOutlined } from '@ant-design/icons';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
export const applicationManagementSubMenu = {
    children: [
        {
            className: 'data-security-menu-item',
            feature: FeatureFlag.DataSecurityDashboard,
            key: FULL_ROUTES.DATA_SECURITY,
            label: COPY_SPECIFIC.APPLICATION_OVERVIEW,
            route: FULL_ROUTES.DATA_SECURITY
        },
        {
            className: 'application-explorer-menu-item',
            feature: FeatureFlag.DataSecurityDashboard,
            key: 'application-explorer',
            label: React.createElement(ApplicationExplorerMenuItem, null)
        },
        {
            className: 'data-security-api-volume-menu-item',
            feature: FeatureFlag.DataSecurityDashboard,
            key: FULL_ROUTES.DATA_SECURITY_API_VOLUME,
            label: COPY_SPECIFIC.API_VOLUME_EXPLORER,
            route: FULL_ROUTES.DATA_SECURITY_API_VOLUME
        },
        {
            className: 'integrated-apps-menu-item',
            key: FULL_ROUTES.DATA_SECURITY_APPLICATION_SETUP,
            label: COPY_SPECIFIC.APPLICATION_SETUP,
            route: FULL_ROUTES.DATA_SECURITY_APPLICATION_SETUP
        }
    ],
    icon: React.createElement(DashboardOutlined, null),
    id: 'application-management-submenu',
    key: 'application-management',
    label: COPY_SPECIFIC.APPLICATION_MANAGEMENT
};
